import React, { useState } from 'react';
import '../css/MasterPage.css'
import { FaAnchor, FaReact, FaToolbox, FaApple, FaGithub, FaLinkedin, FaInstagram, } from "react-icons/fa6";
import Hamburger from '../components/Hamburger';
import Menu from '../components/Menu';
import LeafStorm from '../components/LeafStorm';
import { SiCsswizardry, SiDocker, SiJavascript, SiPostgresql, SiSwift, SiUnity } from "react-icons/si";

export default function Landing({ setActivePage }) {
    const [open, setOpen] = useState(false);
    const handleButtonClick = (pageName) => {
        setActivePage(pageName);
    }
    const handleSocialClick = (socialType) => {
        const urls = {
            github: 'https://github.com/tiredandsad',
            linkedin: 'https://www.linkedin.com/in/milliemelton/',
            instagram: 'https://www.instagram.com/specific_mills/',
        };

        const url = urls[socialType];
        if (url) {
            window.open(url, '_blank');
        }
    };

    return (
        <div className='pageContainer'>
            <LeafStorm active={open} />
            <div className='navBar'>
                <a className='anchor'>🌸</a>
                <Hamburger open={open} setOpen={setOpen} />
                {open && <Menu isOpen={open} setActivePage={setActivePage} />}
            </div>
            <div className='phantomMenuContainer' />
            <div className='pageContent'>
                <p className='header'>Hi, I'm Millie.</p>
                <div className='contentRow'>
                    <div className='leftContent'>
                        <p className='subHeader leftAlign' >Web Developer</p>
                        <p className='subHeader iTwo leftAlign'>Tech Enthusiast</p>
                        <p className='subHeader iThree leftAlign'>Amatuer Mechanic</p>
                        <p className='blurb'>Over 3 years of development experience working with different tools to build unique and quality results
                            for clients. I have intermediate experince in front end web development mainly leveraging the React framework.
                        </p>
                    </div>
                    <div className='rightContent'>
                        <img src='/Emoji.png' />
                    </div>
                </div>
                <div className='tools'>
                    <div className='toolsRow'>
                        <FaToolbox className='toolTitle' />
                        <p className='toolTitle'>Tools</p>
                    </div>
                    <div className='toolsRow'>
                        <p className='toolName'><FaReact className='toolIcon' />  React</p>
                        <p className='toolName'><FaApple className='toolIcon' />  MacOS</p>
                        <p className='toolName'><SiCsswizardry className='toolIcon' />  CSS</p>
                        <p className='toolName'><SiJavascript className='toolIcon' />  JavaScript</p>
                    </div>
                    <div className='toolsRow'>
                        <p className='toolName'><SiDocker className='toolIcon' />  Docker</p>
                        <p className='toolName'><SiUnity className='toolIcon' />  Unity</p>
                        <p className='toolName'><SiPostgresql className='toolIcon' />  PostgreSQL</p>
                        <p className='toolName'><SiSwift className='toolIcon' />  Swift</p>
                    </div>
                </div>
                {/* <div className='contentRow'>
                    <div className='centeredContent'>
                        <div className='examplesButton' onClick={() => handleButtonClick('examples')}>Peep My Projects</div>
                    </div>
                </div> */}
                <div className='contentRow'>
                    <div className="socialLinksRow">
                        <div className="socialLink github" onClick={() => handleSocialClick('github')}>
                            <FaGithub className='shadowIcon' />
                            <p className='hideable'>GitHub</p>
                        </div>
                        <div className="socialLink linkedin" onClick={() => handleSocialClick('linkedin')}>
                            <FaLinkedin className='shadowIcon' />
                            <p className='hideable'>LinkedIn</p>
                        </div>
                        <div className="socialLink instagram" onClick={() => handleSocialClick('instagram')}>
                            <FaInstagram className='shadowIcon' />
                            <p className='hideable'>Instagram</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}